import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import './About.css';

const About = () => {
  const { t } = useTranslation();

  const certificates = [];

  return (
    <div className="page about-page">
      <Helmet>
        <title>{t('navbar.about')} - TA2GBO</title>
      </Helmet>
      <h2>{t('about.title')}</h2>
      
      <div className="about-content">
        <div className="profile-section">
          <img 
            src="/images/profile.jpg" 
            alt="TA2GBO" 
            className="profile-img"
            onError={(e) => {e.target.onerror = null; e.target.src="https://via.placeholder.com/400x500?text=TA2GBO"}}
          />
        </div>
        <div className="bio-section">
          <p>{t('about.bio1')}</p>
          <p>{t('about.bio2')}</p>
          <p>{t('about.bio3')}</p>
        </div>
      </div>

      {certificates.length > 0 && (
        <div className="certificates-section">
          <h3>{t('about.certificatesTitle')}</h3>
          <div className="certificates-list">
            {certificates.map(cert => (
              <div key={cert.id} className="certificate-item">
                <span className="cert-title">{t(cert.title)}</span>
                <span className="cert-year">{cert.year}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default About;